import { render } from "./OpenInBrowser.vue?vue&type=template&id=77481fdc"
import script from "./OpenInBrowser.vue?vue&type=script&lang=js"
export * from "./OpenInBrowser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/OpenInBrowser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77481fdc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77481fdc', __exports__)) {
    api.reload('77481fdc', __exports__)
  }
  
  module.hot.accept("./OpenInBrowser.vue?vue&type=template&id=77481fdc", () => {
    api.rerender('77481fdc', render)
  })

}


export default __exports__